export default function AppSection() {
  return (
    <section id="app" className="section-anchor py-14 md:py-20 bg-primary-600 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20red%20abstract%20texture%20with%20subtle%20wave%20patterns%2C%20minimal%20geometric%20composition%2C%20deep%20burgundy%20and%20crimson%20gradient%2C%20professional%20modern%20design%2C%20no%20text%2C%20no%20people&width=1600&height=600&seq=app-bg-911&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-700/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1024px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">随时随地吃瓜</h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-[600px] mx-auto mb-8">
          关注911爆料网官方渠道，不错过任何一条热门911吃瓜爆料。微信、微博、抖音全平台同步更新，随时随地掌握最新八卦动态。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {[
            { icon: 'ri-wechat-line', label: '微信公众号', desc: '每日推送精选爆料' },
            { icon: 'ri-weibo-line', label: '微博关注', desc: '实时追踪热点话题' },
            { icon: 'ri-tiktok-line', label: '抖音号', desc: '视频解读热门事件' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-3 bg-background-50/10 backdrop-blur-sm border border-background-50/20 rounded-xl px-5 py-4 min-w-[200px] cursor-pointer hover:bg-background-50/20 transition-colors">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${item.icon} text-background-50 text-2xl`}></i>
              </div>
              <div className="text-left">
                <div className="text-sm font-semibold text-background-50 whitespace-nowrap">{item.label}</div>
                <div className="text-xs text-background-50/70 whitespace-nowrap">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}